// Styles
import styles from './TablePaginationNavigation.module.css';

/**
 * TablePaginationNavigation component — pagination controls (e.g. page numbers)
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Navigation controls
 * @returns {JSX.Element} The TablePaginationNavigation component
 */
function TablePaginationNavigation({
  children,
}) {
  return (
    <div className={styles['table-pagination-navigation']}>
      <div className={styles['table-pagination-navigation-controls']}>
        {children}
      </div>
    </div>
  );
}

export default TablePaginationNavigation;
